module.exports = __webpack_public_path__ + "static/img/app_download_bg.163a6c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appDownload/app_download_bg.png
// module id = +mRv
// module chunks = 0